import React from "react";

/**
 * Logo officiel Qonto (papillon noir).
 * 4 pétales en forme de teardrop (large à l'extérieur, pointu au centre),
 * disposés en croix à 90° autour du centre.
 *
 * Props :
 *   - size : taille totale (px). 22 par défaut.
 *   - color : couleur des pétales. "black" par défaut.
 *   - withText : afficher "Qonto" à côté.
 */
export const QontoLogo = ({ size = 22, color = "black", withText = true, className = "" }) => {
  // Pétale teardrop pointant vers le haut.
  // - large (et arrondi) au sommet : (32, 4)
  // - pointu au centre : (32, 32)
  // Forme générée avec deux courbes de Bézier symétriques.
  const petal = "M32 32 C 40 24, 40 12, 32 4 C 24 12, 24 24, 32 32 Z";

  return (
    <span className={`inline-flex items-center align-middle ${className}`} aria-label="Qonto" style={{ gap: "2px" }}>
      <svg
        viewBox="0 0 64 64"
        width={size}
        height={size}
        aria-hidden
        fill={color}
        style={{ flexShrink: 0 }}
      >
        <g transform="rotate(45 32 32)">
          <path d={petal} />
          <path d={petal} transform="rotate(90 32 32)" />
          <path d={petal} transform="rotate(180 32 32)" />
          <path d={petal} transform="rotate(270 32 32)" />
        </g>
      </svg>
      {withText && (
        <span
          className="font-bold"
          style={{
            color,
            fontSize: size * 0.85,
            letterSpacing: "-0.03em",
            lineHeight: 1,
            fontFamily:
              '"Inter", -apple-system, BlinkMacSystemFont, "Helvetica Neue", Arial, sans-serif',
            fontWeight: 700,
          }}
        >
          Qonto
        </span>
      )}
    </span>
  );
};

export default QontoLogo;
